var exports = {
  "Kk": "shared.module__icon___WS11bH",
  "Bx": "shared.module__iconSmall___WS11bH",
};

module.exports = exports;
